// Enable waiting cursor to act as a poor's man visual loader
// Use it when a call is long and you need to inform the user that something is happening

const visualLoaderClass = "visual_loader_on";

export function enableVisualLoader() {
  document.querySelector("body").classList.add(visualLoaderClass);
}

export function disableVisualLoader() {
  document.querySelector("body").classList.remove(visualLoaderClass);
}
